/*
    Generated file
    Do not alter.
    19-08-2020 22:41:00
 */
import axios from 'axios';

export default function ApiHandler(apiUrl) {
    let baseurl = "";
    if (process.env.NODE_ENV == "development")
        baseurl = 'http://dev.safesyteservice.com/api/api/Sproc/';
    else
        baseurl = '/api/api/Sproc/';

    this.axios = axios;
    this.apiUrl = apiUrl || baseurl;
    this.config = {
        headers: { "content-type": "application/json" },
        baseURL: this.apiUrl,
        withCredentials: true,
    };
    this.configBlob = {
        headers: { "content-type": "application/json" },
        baseURL: this.apiUrl,
        withCredentials: true,
        responseType: 'blob',
    };
}


    // pProfielbeheerDashboardsGet
    ApiHandler.prototype.pProfielbeheerDashboardsGet = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('pProfielbeheerDashboardsGet' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pProfielenGet
    ApiHandler.prototype.pProfielenGet = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('pProfielenGet' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pProfielGet
    ApiHandler.prototype.pProfielGet = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('pProfielGet' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pProfielSave
    ApiHandler.prototype.pProfielSave = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('pProfielSave' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pRollenGet
    ApiHandler.prototype.pRollenGet = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('pRollenGet' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pUserGet
    ApiHandler.prototype.pUserGet = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('pUserGet' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pUserSave
    ApiHandler.prototype.pUserSave = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('pUserSave' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pUsersGet
    ApiHandler.prototype.pUsersGet = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('pUsersGet' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pAfdelingGetList
    ApiHandler.prototype.pAfdelingGetList = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('pAfdelingGetList' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pGetProjectList
    ApiHandler.prototype.pGetProjectList = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('pGetProjectList' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pProjectGetMaanden
    ApiHandler.prototype.pProjectGetMaanden = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('pProjectGetMaanden' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pProjectGetTree
    ApiHandler.prototype.pProjectGetTree = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('pProjectGetTree' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pProjectGetWeken
    ApiHandler.prototype.pProjectGetWeken = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('pProjectGetWeken' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pRegistratieTypeGetMeldingOnveilig
    ApiHandler.prototype.pRegistratieTypeGetMeldingOnveilig = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('pRegistratieTypeGetMeldingOnveilig' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pRegistratieTypeGetMeldingVeilig
    ApiHandler.prototype.pRegistratieTypeGetMeldingVeilig = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('pRegistratieTypeGetMeldingVeilig' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pAppMeldingDashboard
    ApiHandler.prototype.pAppMeldingDashboard = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('pAppMeldingDashboard' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pProjectDashboardActies
    ApiHandler.prototype.pProjectDashboardActies = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('pProjectDashboardActies' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pProjectDashboardFactorenEenvoudig
    ApiHandler.prototype.pProjectDashboardFactorenEenvoudig = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('pProjectDashboardFactorenEenvoudig' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pProjectDashboardIndicatiefRisicoEenvoudig
    ApiHandler.prototype.pProjectDashboardIndicatiefRisicoEenvoudig = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('pProjectDashboardIndicatiefRisicoEenvoudig' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pProjectDashboardOngevallen
    ApiHandler.prototype.pProjectDashboardOngevallen = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('pProjectDashboardOngevallen' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // Login
    ApiHandler.prototype.Login = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('Login' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // Logout
    ApiHandler.prototype.Logout = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('pUserLogout' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // RequestPasswordReset
    ApiHandler.prototype.RequestPasswordReset = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('RequestPasswordReset' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // PasswordReset
    ApiHandler.prototype.PasswordReset = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('PasswordReset' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // Authenticated
    ApiHandler.prototype.Authenticated = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('pAuthenticated' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // ValidationRulesGet
    ApiHandler.prototype.ValidationRulesGet = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('pValidationRulesGet' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }



    // Download
    ApiHandler.prototype.saveDownload = function(data, filename) {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
    }